module.exports = __webpack_public_path__ + "img/s2.37c53919.png";